import { type ReactNode } from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowRight02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { cx } from "shared/utils/classnames";
import { useInboxEmbed } from "../context/useInboxEmbed";

export const RoutingFieldsRow = ({
  from,
  to
}: {
  from: ReactNode;
  to: ReactNode;
}) => {
  const isCompact = Boolean(useInboxEmbed()?.compact);
  const groupClass = cx(
    "flex items-center gap-2 text-sm",
    isCompact ? "min-w-0 flex-1" : ""
  );
  const fieldClass = "min-w-0" + (isCompact ? " flex-1" : "");

  return (
    <div className="flex flex-col md:flex-row md:items-center gap-4">
      <div className={groupClass}>
        <span className="text-content-400 font-medium whitespace-nowrap">
          From:
        </span>
        <div className={fieldClass}>{from}</div>
      </div>

      <HugeiconsIcon
        icon={ArrowRight02Icon}
        size={16}
        className="text-content-200 hidden md:block"
      />

      <div className={groupClass}>
        <span className="text-content-400 font-medium whitespace-nowrap">
          To:
        </span>
        <div className={fieldClass}>{to}</div>
      </div>
    </div>
  );
};
